import _styled, { css as _css, default as _styled2 } from "styled-components";
import { useFragment, type FragmentType } from "~/gql/runtime";
import { useNavLayout } from "~/features/app/landing-header/context";
import { Link } from "~/features/ui/link";
import { Button, type ButtonVariant } from "~/features/ui/button";
import { fragment as linkFragment } from "~/features/ui/link/utils";
import ArrowRight from "~/public/icons/arrow-right.svg";
type Props = {
  variant?: keyof typeof variants;
  supportLink?: FragmentType<typeof linkFragment>;
  supportLinkVariant?: string;
};
const variants = {
  transparent: {
    "borderColor": "rgba(255, 255, 255, 0.2)",
    "backgroundColor": "rgba(0, 7, 4, 0.3)",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  solid: {
    "borderColor": "rgb(0 7 4 / 0.1)",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(244 244 249 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(0 7 4 / var(--tw-text-opacity))"
  },
  highlighted: {
    "borderColor": "rgb(0 7 4 / 0.1)",
    "backgroundColor": "var(--white-static)",
    "color": "var(--black-static)"
  }
} as const;
const buttonWrapperVariants = {
  underline: _css(["", " a{", "}a::after{", "}a::before{", "}"], {
    "display": "flex",
    "height": "100%",
    "alignItems": "center",
    "justifyContent": "center",
    "columnGap": "1.6rem",
    "paddingLeft": "var(--spacing-xl)",
    "paddingRight": "var(--spacing-xl)",
    "@media (min-width: 1024px)": {
      "columnGap": "2.4rem"
    }
  }, {
    "padding": "0"
  }, {
    "display": "none"
  }, {
    "display": "none"
  }),
  default: _css(["", ""], {
    "display": "flex",
    "height": "100%",
    "alignItems": "center",
    "justifyContent": "center",
    "columnGap": "1.6rem",
    "paddingLeft": "0.8rem",
    "paddingRight": "0.8rem",
    "@media (min-width: 1024px)": {
      "columnGap": "2.4rem"
    }
  })
};
export function NavHamburger(props: Props) {
  const {
    variant,
    supportLink: supportLinkRef,
    supportLinkVariant
  } = props;
  const supportLink = useFragment(linkFragment, supportLinkRef);
  const {
    navTheme,
    isPageHighlighted
  } = useNavLayout();
  const surface = isPageHighlighted ? "highlighted" : variant || navTheme;
  if (!supportLink?.href) {
    return null;
  }
  const buttonVariant = supportLinkVariant?.toLowerCase() as ButtonVariant || "secondary";
  return <_StyledDiv $_css2={[{
    "pointerEvents": "auto",
    "position": "relative",
    "zIndex": "10",
    "flexShrink": "0",
    "borderBottomWidth": "1px",
    "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke",
    "transitionDuration": "250ms",
    "transitionTimingFunction": "ease-in-out"
  }, variants[surface]]}>
      <_StyledDiv2 $_css3={buttonWrapperVariants[buttonVariant === "underline" ? "underline" : "default"]}>
        <Button as={Link} {...supportLink} variant={buttonVariant} icon={buttonVariant !== "underline" ? ArrowRight : undefined} />
      </_StyledDiv2>
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-blkj6m-0"
})`${p => p.$_css2}`;
var _StyledDiv2 = /*#__PURE__*/_styled2("div").withConfig({
  displayName: "nav-hamburger___StyledDiv2",
  componentId: "sc-1fblged-0"
})(["", ""], p => p.$_css3);